import React from "react";

// Inline copy of public/images/logo-only.svg so it can take any colour (via
// currentColor / Tailwind text-* classes) and animate.
//   animated="loader" -> gentle breathing + blinking dots, for loading states
const Logo = ({ className = "w-10", animated, title = "Linkakam" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1363.11 744.93"
    role="img"
    aria-label={title}
    className={`text-[#672ed0] ${className}`}
    fill="currentColor"
  >
    {animated === "loader" && (
      <style>{`
        @keyframes lk-breathe { 0%,100% { transform: scale(1); opacity: 1 } 50% { transform: scale(.94); opacity: .7 } }
        @keyframes lk-blink { 0%,45%,55%,100% { transform: scaleY(1) } 50% { transform: scaleY(.1) } }
        .lk-body { transform-origin: 50% 50%; animation: lk-breathe 1.6s ease-in-out infinite }
        .lk-dot { transform-box: fill-box; transform-origin: center; animation: lk-blink 2.4s ease-in-out infinite }
        @media (prefers-reduced-motion: reduce) { .lk-body, .lk-dot { animation: none } }
      `}</style>
    )}
    <g className={animated === "loader" ? "lk-body" : undefined}>
      <g transform="translate(-1.89 -11.76)">
        <path d="M608.37,355.34H739c-33.44-75.49-47.09-158.11-117-230.55C454.9-54.72,155.61-9.93,45.77,196.93c-133,265.24,48.17,554.78,383.33,531.24l9.25,28.52,147.09-88.1s-134.37-81.38-147-87.82l-4.28,27.51c-81.84,1.91-172.07,9.3-256.26-82.66-76.06-103-71.17-186.49-24-278.47C230.2,118.94,408.88,89,519.75,191.51,574.61,259.61,584.45,300.45,608.37,355.34Z" />
        <path d="M628.84,412.84H757.13c28.32,53,58.27,146.92,111.79,180.23,49.64,39,119.36,50.86,180.71,40.4C1151.71,616,1234,527.05,1245.15,424.3c15.24-138-93.34-263.43-232.79-265-20.38.05-50.3,0-70.66,0-1.89.3-5.92-.63-5.84,2.58-2.06,5.92,2.6,23.16-6.61,24-47.37-23.65-100-56.53-145.86-83.77a7.68,7.68,0,0,1-1.57-1.2,7.52,7.52,0,0,1-.87-1.41s.09-1.38.18-1.72c.33-1.48,1.85-2.23,2.78-2.84l1.77-1.11,20.26-12.11c36.49-21.92,83-48.35,120.3-69.38,2.93-1.66,5.61.74,7,3.35,3.13,3.82.46,18.38,2.06,22.84,1.18,1.84,4.85,1.62,6.78,2.15,49.91,0,104.82-2.47,153.44,10.39,226.61,60.9,337.44,312.74,225.4,520-100.19,179.57-333,240.9-506.57,129.06-55-35.65-102.28-89.15-131.5-147.86C665.32,508.51,642,457.73,628.84,412.84Z" />
      </g>
      <circle className={animated === "loader" ? "lk-dot" : undefined} cx="1005.36" cy="387.12" r="76.25" />
      <circle className={animated === "loader" ? "lk-dot" : undefined} cx="357.41" cy="358.44" r="76.25" />
    </g>
  </svg>
);

export default Logo;
